import {
	ContextMenu as RadixContextMenu,
	DropdownMenu as RadixDropdownMenu,
	Menubar as RadixMenubar,
} from "radix-ui";

export type MenuType = "menu" | "context-menu" | "menu-bar";
export type TypeComponent =
	| typeof RadixDropdownMenu
	| typeof RadixContextMenu
	| typeof RadixMenubar;

export type TypeRootComponent =
	| typeof RadixDropdownMenu.Root
	| typeof RadixContextMenu.Root
	| typeof RadixMenubar.Menu;

export function getTypeComponent(type: MenuType): TypeComponent {
	switch (type) {
		case "menu":
			return RadixDropdownMenu;
		case "context-menu":
			return RadixContextMenu;
		case "menu-bar":
			return RadixMenubar;
	}
}

export function getTypeRootComponent(type: MenuType): TypeRootComponent {
	switch (type) {
		case "menu":
			return RadixDropdownMenu.Root;
		case "context-menu":
			return RadixContextMenu.Root;
		case "menu-bar":
			return RadixMenubar.Menu;
	}
}
